<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Usuarios",
            items: [
                {
                text: "Usuarios",
                href: "/web/configuracion/usuarios"
                },
            ],
            usuarios:[],
            datos_editar:{
                sede:'',
                tipo:'',
                rut:'',
                nombre:'',
                correo:'',
                telefono:'',
            },
            habilitar_boton: false,  
            editing: false,
            originalUser:'',
            emailError:'',
            phoneerror:'',
            ruterror:'',
            sedes:['Viña del Mar', 'Santiago', 'Concepción'],
            cargos:['Coordinador Vigente','Coordinador de reemplazo','Supervisor','Supervisor General']
        };
    },
    computed: {
    
    },
    mounted() {
    },
    methods: {
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        toggleEdit(usuario) {
            this.originalUser = { ...usuario };
            if (this.editing) {
                this.isLoading=true
                axios.post('/api/editar_usuario',this.datos_editar).then(res=>{
                    if(res.data.estado){
                        this.usuarios=res.data.usuarios;
                        this.msg(res.data.color,res.data.mensaje);
                        //window.location.reload(); 
                    }else{
                        this.msg(res.data.color,res.data.mensaje);
                    }
                    this.isLoading=false
                })
            }else{
                this.datos_editar.id=usuario.id;
                this.datos_editar.name=usuario.name;
                this.datos_editar.rut=usuario.rut;
                this.datos_editar.sede=usuario.sede;
                this.datos_editar.email=usuario.email;
                this.datos_editar.cargo=usuario.cargo;
                this.datos_editar.telefono=usuario.telefono;
            }
            this.editing = !this.editing;
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        ver_mas(usuario){
            this.editing = false;
            if (usuario.boton=='Ver más') {
                usuario.boton='Ver menos'
            }else if(usuario.boton=='Ver menos'){
                usuario.boton='Ver más'
            }
        },
        formatRut() {
            // Eliminamos todos los caracteres que no sean números o 'k'
            let cleanRut = this.datos_editar.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10); // Limitar a 9 dígitos + DV
            }
            // Si el RUT tiene más de un carácter, separamos el dígito verificador
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1); // Todo menos el último carácter
                const dv = cleanRut.slice(-1); // Último carácter como dígito verificador
                // Agregamos los puntos cada tres dígitos al cuerpo
                const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // Concatenamos el cuerpo formateado con el dígito verificador
                this.datos.rut = `${formattedBody}-${dv}`;
            } else {
                // Si el RUT tiene un solo carácter, lo dejamos tal cual
                this.datos_editar.rut = cleanRut;
            }
        },
        cleanRut(value) {
            return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        validateRut() {
            let rut = this.cleanRut(this.datos_editar.rut);
            let digito_verificador = this.datos_editar.rut.substr(-1);
            rut = rut.substr(0, rut.length - 1);
            let serie = 0;
            let producto = 0;
            do {
                producto += (rut % 10) * ((serie % 6) + 2);
                serie++;
            } while (rut = Math.floor(rut / 10));
            let resto = producto % 11;
            let resultado = 11 - resto;
            if (resultado == 11) {
                resultado = 0;
            } else if (resultado == 10) {
                resultado = 'K';
            }
            if (digito_verificador != resultado || digito_verificador=='') {
                this.ruterror = 'RUT inválido';
            } else {
                this.ruterror = '';
            }
        },
        validateEmail() {
            if (this.datos_editar.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.datos_editar.telefono.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.datos_editar.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.datos_editar.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        eliminar(usuario){
            let formData = new FormData();
            formData.append('usuario_id', usuario.id);
            axios.post('/api/eliminar_usuario',formData).then(res=>{
                if(res.data.estado){
                    this.usuarios=res.data.usuarios;
                    this.msg(res.data.color,res.data.mensaje);
                }else{
                    this.msg(res.data.color,res.data.mensaje);
                }
            })
        }
    },
    created(){
        axios.get('/api/get_usuarios').then(res=>{
            this.usuarios=res.data.usuarios;
        });
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-12 mb-3">
                                <b-button class="float-right" variant="primary" href="/web/configuracion/crearusuario">Agregar Usuario</b-button>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 20px;">#</th>
                                        <th style="width: 400px;">Nombre</th>
                                        <th style="width: 150px;">Rut</th>
                                        <th class="text-right">Detalle</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div class="table-responsive" v-for="(usuario,index) in usuarios" :key="index">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <th style="width: 20px;">{{ index+1 }}</th>
                                        <td style="width: 400px;">{{usuario.name}}</td>
                                        <td style="width: 150px;">{{usuario.rut}}</td>
                                        <td class="text-right">
                                            <b-button v-b-toggle="'accordion-'+usuario.id" variant="secondary" @click="ver_mas(usuario)">
                                                {{usuario.boton}}
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <b-collapse :id="'accordion-'+usuario.id" accordion="my-accordion" role="tabpanel">
                                <div class="row">
                                    <div class="col-md-12" >
                                        <div class="card mt-3 shadow-sm border-light">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h1 class="text-primary mb-4">{{ editing ?  usuario.name : usuario.name }}</h1>
                                                        <div class="row" v-if="editing">
                                                            <div class="col-md-6">
                                                                <div class="form-group">
                                                                    <label for="pais"> Nombre:</label>
                                                                    <input type="text" id="pais" v-model="datos_editar.name" class="form-control border-primary" @keydown="restrictInput_withspace">
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="name"> Sede:</label>
                                                                    <multiselect
                                                                        v-model="datos_editar.sede"
                                                                        :options="sedes" 
                                                                        placeholder="Seleccionar opción" 
                                                                        selectLabel="Presiona para seleccionar"
                                                                        selectedLabel="Seleccionado"
                                                                        deselectLabel="Presiona para remover"
                                                                        >
                                                                        <template v-slot:noOptions>
                                                                            <p>No hay opciones</p>
                                                                        </template>
                                                                        <template v-slot:noResult>
                                                                            <p>No se encuentra coincidencia</p>
                                                                        </template>
                                                                    </multiselect>
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="direccion"> Correo Electrónico:</label>
                                                                    <input type="text" id="direccion" v-model="datos_editar.email" class="form-control border-primary" @blur="validateEmail">
                                                                    <p v-if="emailError" class="error text-primary">{{ emailError }}</p>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <div class="form-group">
                                                                    <label for="telefono"> Rut:</label>
                                                                    <input type="text" id="telefono" v-model="datos_editar.rut" class="form-control border-primary" @blur="validateRut" @input="formatRut" maxlength="12">
                                                                    <p v-if="ruterror" class="error text-primary">{{ ruterror }}</p>
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="telefono"> Tipo de Usuario:</label>
                                                                    <multiselect
                                                                        v-model="datos_editar.cargo"
                                                                        :options="cargos" 
                                                                        placeholder="Seleccionar opción" 
                                                                        selectLabel="Presiona para seleccionar"
                                                                        selectedLabel="Seleccionado"
                                                                        deselectLabel="Presiona para remover"
                                                                        >
                                                                        <template v-slot:noOptions>
                                                                            <p>No hay opciones</p>
                                                                        </template>
                                                                        <template v-slot:noResult>
                                                                            <p>No se encuentra coincidencia</p>
                                                                        </template>
                                                                    </multiselect>
                                                                </div>
                                                                <div class="form-group">
                                                                    <label for="email"> Teléfono:</label>
                                                                    <input type="email" id="email" v-model="datos_editar.telefono" class="form-control border-primary" @input="formatPhoneNumber" @blur="validatePhoneNumber" @keydown="restrictToNumbers" maxlength="12">
                                                                    <p v-if="phoneerror" class="error text-primary">{{ phoneerror }}</p>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                        <div class="row" v-else>
                                                            <div class="col-md-6">
                                                                <p class="font-size-16"><strong>Nombre:</strong> {{ usuario.name }}</p>
                                                                <p class="font-size-16"><strong>Sede:</strong> {{ usuario.sede }}</p>
                                                                <p class="font-size-16"><strong>Correo Electrónico:</strong> {{ usuario.email }}</p>
                                                                <p class="font-size-16"><strong>Nº Colegios Asignados:</strong> {{ usuario.colegios_asignados }}</p>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="font-size-16"><strong>Rut:</strong> {{ usuario.rut }}</p>
                                                                <p class="font-size-16"><strong>Tipo de Usuario:</strong> {{ usuario.cargo }}</p>
                                                                <p class="font-size-16"><strong>Teléfono:</strong> {{ usuario.telefono }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="mt-3 float-right">
                                                            <button v-if="editing" @click="cancelEdit" class="btn btn-secondary">
                                                                <i class="fas fa-times"></i> Cancelar
                                                            </button>
                                                            <button @click="toggleEdit(usuario)" class="btn btn-primary">
                                                                <i :class="editing ? 'fas fa-save' : 'fas fa-edit'"></i> {{ editing ? 'Guardar cambios' : 'Editar' }}
                                                            </button>
                                                            <b-button variant="danger" v-if="!editing" @click="eliminar(usuario)"><i class="bx bx-trash"></i></b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>